<template>
  <article>
    <MastheadAlt
      subtitle="Link in bio for Non-profits"
      title="Share your message. Increase your impact."
      text="Make it easy for your followers to learn more about you with everywhere you are in a single link. Campsite.bio is the easiest way to manage your bio link."
      ctaText="(50% off discount available to non-profits)"
      :profile-images="[
        '/campsites/non-profit/campsite-hmchospital.png',
        '/campsites/non-profit/campsite-liveatubc.png',
        '/campsites/non-profit/campsite-naturallyboulder.png',
        '/campsites/non-profit/campsite-providence.png',
        '/campsites/non-profit/campsite-triagecancer.png',
        '/campsites/non-profit/campsite-campmendocino.png',
        '/campsites/non-profit/campsite-menorahpark.png',
        '/campsites/non-profit/campsite-wbftv.png',
        '/campsites/non-profit/campsite-crusdsu.png',
        '/campsites/non-profit/campsite-visitschohariecounty.png',
        '/campsites/non-profit/campsite-redlandssymphony.png',
        '/campsites/non-profit/campsite-lwcgwc.png',
        '/campsites/non-profit/campsite-air1radio.png',
        '/campsites/small-business/campsite-friendlypinescamp.png',
        '/campsites/non-profit/campsite-sundanceorg.png',
      ]"
    >
      <Button href="https://app.campsite.bio/create-account" size="large"
        >Get started</Button
      >
    </MastheadAlt>

    <SeenOn />

    <!-- <TestimonialSection
      title="Campsite.bio has helped my business and my audience grow"
      img-src="/campsites/small-business/campsite-smallstudio.png"
      name="Ashton Henry"
    >
      <p>
        Having a professional link in bio page is really important to my
        business since most of my traffic comes from different social channels
        like Instagram, Twitter, and LinkedIn - Campsite's features have helped
        me look professional and their embed features have increased my email
        opt-ins, product sales, and YouTube and podcast downloads.
      </p>
      <p>
        I can't recommend Campsite enough if you're looking for a professional
        link in bio to grow your business.
      </p>
    </TestimonialSection> -->

    <LargeTextSection
      >As a non-profit, your time is valuable. Stop worrying about updating your
      bio link and create a singular repository for your most important links
      with a Campsite.bio profile.</LargeTextSection
    >

    <FeatureSection
      title="Get a professional link in bio for a discounted price"
    >
      <VText slot="text"
        >Campsite.bio offers a suite of features for half the price to
        non-profits. We believe that helping causes that are doing good is
        important.</VText
      >

      <FeatureCard
        title="Non-profit discount"
        bg-color="secondary"
        color="secondary"
      >
        <WandIcon slot="icon" />
        <VText
          >We offer a 50% discount on any of our plans, even with modifications.
          Need to manage 10 profiles? 50% off. Need to invite 5 collaborators?
          50% off.
        </VText>
      </FeatureCard>
      <FeatureCard title="Donation collection">
        <PaymentIcon slot="icon" />
        <VText>
          Collect donations from your supporters directly on your bio link page
          with the Support link. Reduce the steps for your supporters to support
          you.
        </VText>
      </FeatureCard>
      <FeatureCard title="Profile management">
        <AccountMultipleIcon slot="icon" />
        <VText>
          We make it easy to manage multiple profiles under a single account.
          Our profile management features help you do more without any of the
          headaches of multiple logins.
        </VText>
      </FeatureCard>
      <FeatureCard title="Collaborators">
        <PersonAddIcon slot="icon" />
        <VText>
          Invite your teammates to help manage your profiles with our
          collaborators feature. Give them access to specific profiles with only
          the permissions they need.
        </VText>
      </FeatureCard>
    </FeatureSection>

    <FeatureSection
      title="Unlock premium features for a not so premium price"
      bg-color="gray100"
    >
      <VText slot="text"
        >Forgot about the limitations of a free plan and focus on your
        mission.</VText
      >
      <Button slot="cta" to="/pricing">Compare features</Button>

      <FeatureCard title="Automation">
        <SettingsIcon slot="icon" />
        <VText
          >Keep your profile fresh with our automated link types, like the feed
          and image grid. They'll pull in the newest content from Youtube, a
          blog, or Instagram, automatically.
        </VText>
      </FeatureCard>
      <FeatureCard title="Premium link types">
        <GridIcon slot="icon" />
        <VText
          >Unlock our best link types with multiple carousels, opt-in forms,
          feed links, forms (Typeform and Jotform), image grids and so much
          more.</VText
        >
      </FeatureCard>
      <FeatureCard title="Scheduling links">
        <EventIcon slot="icon" />
        <VText
          >Do you have timed promotions or events? Put up and take down your
          links at specific times with our scheduling features.
        </VText>
      </FeatureCard>
      <FeatureCard title="Highlight a link">
        <StarIcon slot="icon" />
        <VText
          >Draw attention to your most important link with a highlight
          animation.
        </VText>
      </FeatureCard>
      <FeatureCard title="Multiple profiles">
        <AccountMultipleIcon slot="icon" />
        <VText
          >Manage multiple profiles under a single account. Our profile
          management features help you do more without any of the headaches of
          multiple logins.
        </VText>
      </FeatureCard>
      <FeatureCard title="Custom domain">
        <WebsiteIcon slot="icon" />
        <VText>
          Keep all that trust you've built by using your own domain when sharing
          your bio link (ex. links.mydomain.com).
        </VText>
      </FeatureCard>
    </FeatureSection>

    <RaisedCtaSection
      title="Simplify your link in bio management today"
      text="An easy to use tool to help you focus on what is important."
    >
      <Button href="https://app.campsite.bio/create-account" size="large"
        >Get started</Button
      >
    </RaisedCtaSection>
  </article>
</template>

<script>
import {
  VText,
  Button,
  AccountMultipleIcon,
  PersonAddIcon,
  GridIcon,
  SettingsIcon,
  PaymentIcon,
  EventIcon,
  StarIcon,
  WebsiteIcon,
  WandIcon,
} from '@campsite-bio/component-lib';

import SeenOn from '@/components/seen-on-analytics';
import TestimonialSection from '@/components/testimonials/testimonial-section';
import FeatureCard from '@/components/features/feature-card';
import FeatureSection from '@/components/features/feature-section';
import RaisedCtaSection from '@/components/sections/raised-cta-section';
import LargeTextSection from '@/components/sections/large-text-section';
import MastheadAlt from '@/components/sections/masthead-alt';
import { generateMeta } from '~/utils/generate-meta';

export default {
  components: {
    VText,
    Button,
    SeenOn,
    TestimonialSection,
    FeatureCard,
    FeatureSection,
    AccountMultipleIcon,
    PersonAddIcon,
    GridIcon,
    SettingsIcon,
    PaymentIcon,
    RaisedCtaSection,
    LargeTextSection,
    MastheadAlt,
    EventIcon,
    StarIcon,
    WebsiteIcon,
    WandIcon,
  },

  head() {
    return generateMeta({
      title: 'Link in bio for Non-profits - Campsite.bio',
      description:
        'Share your message. Increase your impact. Learn more about the features Campsite.bio offers to non-profits.',
    });
  },
};
</script>

<style lang="scss" scoped></style>
